import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import moment from "moment";
import { useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";
import "./ResumenVuelos.css";
import './SharedLoading.css';
import API_BASE_URL from "../config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ResumenVuelosPage = () => {
  const token = useSelector((state) => state.auth.token);
  const decoded = token ? jwtDecode(token) : null;

  const [loadingPage, setLoadingPage] = useState(true);
  const [vuelosLlegadas, setVuelosLlegadas] = useState([]);
  const [vuelosSalidas, setVuelosSalidas] = useState([]);
  const [modalAbierto, setModalAbierto] = useState(false);
  const [vueloSeleccionado, setVueloSeleccionado] = useState(null);
  const [mostradores, setMostradores] = useState({});
  const [sillasSeleccionadas, setSillasSeleccionadas] = useState({});
  const [busquedaLlegadas, setBusquedaLlegadas] = useState("");
  const [busquedaSalidas, setBusquedaSalidas] = useState("");
  const [tabActivo, setTabActivo] = useState("LLEGADAS");

  // Registro manual de pasajero que no viene en la lista (FAB +)
  const manualInicial = {
    nombre: "",
    apellido: "",
    noVuelo: "",
    noAsiento: "",
    fecha: moment().format("YYYY-MM-DD"),
    intNac: "INTERNACIONAL", // default seguro; se ajusta desde el modal
  };
  const minFechaManual = moment().format("YYYY-MM-DD");
  const maxFechaManual = moment().add(1, "day").format("YYYY-MM-DD");
  const [modalManualAbierto, setModalManualAbierto] = useState(false);
  const [manualForm, setManualForm] = useState(manualInicial);
  const [guardandoManual, setGuardandoManual] = useState(false);

  const [pasajeros, setPasajeros] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [filtroOrigen, setFiltroOrigen] = useState("TODOS");
  const [pasajerosSeleccionados, setPasajerosSeleccionados] = useState({});
  const [fechaPasajeros, setFechaPasajeros] = useState("");
  const [cargandoPasajeros, setCargandoPasajeros] = useState(false);

  const [guardandoRegistro, setGuardandoRegistro] = useState(false);
  // Asignación directa desde la lista de pasajeros (registra + asigna al operador)
  const [pasajeroAsignar, setPasajeroAsignar] = useState(null);
  const [colaboradores, setColaboradores] = useState([]);
  const [busquedaSiglas, setBusquedaSiglas] = useState("");
  const [asignando, setAsignando] = useState(false);
  const [modalAltaAbierto, setModalAltaAbierto] = useState(false);
  const [guardandoAlta, setGuardandoAlta] = useState(false);
  const altaInicial = {
    flight_number: "",
    latest_departure_airport: "",
    latest_arrival_airport: "",
    hora_salida: "",
    hora_llegada: "",
    tipoServicio: "LLEGADAS",
  };
  const [altaForm, setAltaForm] = useState(altaInicial);

  const AEROPUERTOS_NACIONALES = [
    "ACA","AGU","AZG","CUN","CTM","CUU","CJS","CEN","CME","CUL",
    "DGO","GDL","GYM","HMO","HUX","ZIH","LAP","BJX","LTO","SJD",
    "LMM","ZLO","MZT","MID","MXL","MEX","NLU","MTY","MLM","OAX",
    "TCN","PBC","PXM","PVR","QRO","REX","SLW","SLP","TAM","TAP",
    "TPQ","TIJ","TRC","TGZ","TQO","UPN","VER","VSA","ZCL",
  ];

  const estacionIATA = (decoded?.estacion || "").replace(/[^A-Za-z]/g, "").slice(0, 3).toUpperCase();

  const altaOrigenEfectivo = altaForm.tipoServicio === "SALIDAS"
    ? estacionIATA
    : altaForm.latest_departure_airport.trim().toUpperCase();
  const altaDestinoEfectivo = altaForm.tipoServicio === "LLEGADAS"
    ? estacionIATA
    : altaForm.latest_arrival_airport.trim().toUpperCase();
  const altaTipoVueloDetectado = altaForm.tipoServicio === "LLEGADAS"
    ? (AEROPUERTOS_NACIONALES.includes(altaOrigenEfectivo) ? "NACIONAL" : "INTERNACIONAL")
    : (AEROPUERTOS_NACIONALES.includes(altaDestinoEfectivo) ? "NACIONAL" : "INTERNACIONAL");
  const totalPasajeros = pasajeros.length;
  const totalSillasSistema = pasajeros.filter((p) => p.OrigenServicio === "SABRE").length;
  const minFechaPasajeros = moment().subtract(3, "days").format("YYYY-MM-DD");
  const maxFechaPasajeros = moment().add(3, "days").format("YYYY-MM-DD");
  const generarClavePasajero = (pasajero) =>
    `${(pasajero.pnr || "SINPNR").trim()}_${(pasajero.Nombre || "").trim()}_${(pasajero.Apellido || "").trim()}_${(pasajero.TipoPasajero || "").trim()}`;

  const llegadaRef = useRef(null);
  const salidaRef = useRef(null);

  const fetchData = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}api/vuelos/hoy`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const vuelos = res.data || [];

      // Filtrar por estación del usuario (sin modificar API backend)
      const norm = (s) => (s || "").trim().toUpperCase();
      const estacionUsuario = decoded?.estacion ? norm(decoded.estacion) : null;
      const getEstacionVuelo = (v) =>
        norm(v?.estacion ?? v?.Estacion ?? v?.station ?? v?.stationCode);
      const vuelosFiltrados = estacionUsuario
        ? vuelos.filter((v) => getEstacionVuelo(v) === estacionUsuario)
        : vuelos;

      setVuelosLlegadas(
        vuelosFiltrados
          .filter((v) => v.tipoServicio === "LLEGADAS")
          .sort((a, b) =>
            moment(a.published_arrival_time).diff(moment(b.published_arrival_time))
          )
      );
      setVuelosSalidas(
        vuelosFiltrados
          .filter((v) => v.tipoServicio === "SALIDAS")
          .sort((a, b) =>
            moment(a.published_departure_time).diff(moment(b.published_departure_time))
          )
      );
    } catch (error) {
      console.error("Error al cargar vuelos:", error);
    } finally {
      setLoadingPage(false);
    }
  };

  const claseTiempo = (hora) => {
    const ahora = moment();
    const llegada = moment(hora);
    const diffMin = llegada.diff(ahora, "minutes");

    if (diffMin >= 0 && diffMin <= 15) return "cercano-15";
    if (diffMin <= 30) return "cercano-30";
    if (diffMin <= 60) return "cercano-60";
    return "";
  };

  const cargarPasajeros = async (vuelo, fechaISO) => {
    const fechaBase = moment(vuelo.published_departure_time);
    const fechaSeleccionada = fechaISO ? moment(fechaISO, "YYYY-MM-DD") : moment();
    const fechaConsulta = fechaBase
      .clone()
      .set({
        year: fechaSeleccionada.year(),
        month: fechaSeleccionada.month(),
        date: fechaSeleccionada.date(),
      })
      .format("YYYY-MM-DD HH:mm:ss");

    const MAX_REINTENTOS = 5;
    let ultimoError;
    for (let intento = 0; intento <= MAX_REINTENTOS; intento++) {
      try {
        if (intento > 0) {
          await new Promise((r) => setTimeout(r, 1000 * intento));
          console.log(`🔄 Reintento ${intento}/${MAX_REINTENTOS} para vuelo ${vuelo.flight_number}`);
        }
        const res = await axios.get(`${API_BASE_URL}api/vuelos/pasajeros`, {
          params: {
            numeroVuelo: vuelo.flight_number,
            origen: vuelo.latest_departure_airport,
            published_departure_time: fechaConsulta,
          },
        });
        const listaPasajeros = res.data || [];
        setPasajeros(listaPasajeros);
        const nuevasSillas = {};
        listaPasajeros.forEach((p) => {
          if (["WCHR", "SP", "PAS"].includes(p.TipoSilla)) {
            nuevasSillas[`${p.pnr}_${p.TipoPasajero}`] = p.TipoSilla;
          }
        });
        setSillasSeleccionadas(nuevasSillas);
        setPasajerosSeleccionados({});
        setMostradores({});
        setBusqueda("");
        setFiltroOrigen("TODOS");
        return;
      } catch (err) {
        ultimoError = err;
      }
    }
    throw ultimoError;
  };

  const abrirModalPasajeros = async (vuelo) => {
    try {
      setCargandoPasajeros(true);
      const hoy = moment().format("YYYY-MM-DD");
      await cargarPasajeros(vuelo, hoy);
      setVueloSeleccionado(vuelo);
      setFechaPasajeros(hoy);
      setModalAbierto(true);
    } catch (err) {
      console.error("Error al obtener pasajeros:", err);
      setPasajeros([]);
      toast.error("No se pudieron cargar pasajeros para la fecha seleccionada.");
    } finally {
      setCargandoPasajeros(false);
    }
  };

  const onChangeFechaPasajeros = async (e) => {
    const nuevaFecha = e.target.value;
    setFechaPasajeros(nuevaFecha);
    if (!vueloSeleccionado) return;
    try {
      setCargandoPasajeros(true);
      await cargarPasajeros(vueloSeleccionado, nuevaFecha);
    } catch (err) {
      console.error("Error al obtener pasajeros:", err);
      setPasajeros([]);
      toast.error("No se pudieron cargar pasajeros para la fecha seleccionada.");
    } finally {
      setCargandoPasajeros(false);
    }
  };

  const obtenerBadgeHora = (hora) => {
    const ahora = moment();
    const llegada = moment(hora);
    const diffMin = llegada.diff(ahora, "minutes");

    let clase = "dot-normal";

    if (diffMin >= 0 && diffMin <= 15) clase = "dot-urgente";
    else if (diffMin <= 30) clase = "dot-alerta";

    return (
      <span className="badge-hora">
        <span className={`badge-dot ${clase}`} />
        {llegada.format("HH:mm")}
      </span>
    );
  };

  // Devuelve true (o el id del servicio si paraAsignar) cuando quedó REGISTRADO; false si no.
  const registrarServicioPasajero = async (pasajero, mostrarToast = true, { paraAsignar = false } = {}) => {
    // Guard anti doble-click SOLO cuando se llama directo desde el boton por fila
    // (mostrarToast=true); las llamadas desde registrarSeleccionMultiple pasan false
    // y ya estan protegidas por el flag del multiple.
    if (mostrarToast && guardandoRegistro) return;
    const soyOwner = mostrarToast;
    if (soyOwner) setGuardandoRegistro(true);
    try {
      const payload = {
        nombrePax: `${pasajero.Nombre} ${pasajero.Apellido}`,
        aerolinea: "AM",
        noVuelo: vueloSeleccionado.flight_number,
        noAsiento: pasajero.TipoPasajero,
        origenVuelo: vueloSeleccionado.latest_departure_airport,
        destinoVuelo: vueloSeleccionado.latest_arrival_airport,
        fechaInput: moment().format("YYYY-MM-DD"),
        horaInicio: moment().format("YYYY-MM-DD HH:mm:ss"),
        estacion: decoded?.estacion?.trim().toUpperCase(),
        usuarioInicio: decoded?.id,
        noColaborador: 0,
        statusServicio: "REGISTRADO",
        tipoVuelo: vueloSeleccionado.tipoServicio,
        int_nac: vueloSeleccionado.tipoVuelo,
        pnr: pasajero.pnr,
        tipoSilla:
          sillasSeleccionadas[`${pasajero.pnr}_${pasajero.TipoPasajero}`] || "WCHR",
        conexion: pasajero.Interconexion,
        uh: pasajero.OrigenServicio === "SABRE" ? "normal" : "UH",
        noMostrador:
          vueloSeleccionado.tipoServicio === "SALIDAS"
            ? mostradores[pasajero.pnr] || null
            : null,
        horaVuelo: moment(
          vueloSeleccionado.tipoServicio === "LLEGADAS"
            ? vueloSeleccionado.published_arrival_time
            : vueloSeleccionado.published_departure_time
        ).format("YYYY-MM-DD HH:mm:ss"),
        sala: vueloSeleccionado.sala || null,
        // Campos SABRE de prioridad/clase (se persisten en BD con estos mismos nombres)
        classCode: pasajero.classCode || null,
        priorityCode: pasajero.priorityCode || null,
      };

      const resRegistro = await axios.post(`${API_BASE_URL}api/servicios/registrar`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (mostrarToast) {
        toast.success("✅ Servicio registrado correctamente");
      }
      setPasajerosSeleccionados((prev) => {
        if (!Object.keys(prev).length) return prev;
        const clave = generarClavePasajero(pasajero);
        if (!prev[clave]) return prev;
        const copia = { ...prev };
        delete copia[clave];
        return copia;
      });
      return paraAsignar ? resRegistro.data?.servicioId || false : true;
    } catch (error) {
      if (error.response?.status === 409) {
        const respuesta = error.response?.data || {};
        const statusExistente = (respuesta.statusServicio || "").toString().trim().toUpperCase();
        const servicioId = respuesta.servicioId || respuesta._id || respuesta.id || respuesta.noServicio;
        const noColaboradorAnterior = respuesta.noColaborador ?? 0;
        const usuarioInicioAnterior = respuesta.usuarioInicio ?? 0;

        if (statusExistente === "NOSHOW" && servicioId) {
          try {
            await axios.put(
              `${API_BASE_URL}api/servicios/${servicioId}`,
              {
                noColaboradorAnterior,
                usuarioInicioAnterior,
                noColaborador: 0,
                usuarioInicio: 0,
                statusServicio: "REGISTRADO",
                horaInicio: moment().format("YYYY-MM-DD HH:mm:ss"),
              },
              {
                headers: { Authorization: `Bearer ${token}` },
              }
            );

            if (mostrarToast) {
              toast.success("✅ Servicio re-registrado correctamente");
            }
            return paraAsignar ? servicioId : true;
          } catch (updateError) {
            console.error("❌ Error al re-registrar servicio:", updateError);
            toast.error("No se pudo re-registrar el servicio");
            return false;
          }
        }

        // Ya estaba registrado y sin asignar: se puede asignar directo
        if (paraAsignar && statusExistente === "REGISTRADO" && servicioId) {
          return servicioId;
        }

        toast.warning(" El pasajero ya fue registrado");
      } else {
        console.error("❌ Error al registrar servicio:", error);
        toast.error("Error al registrar servicio");
      }
      return false;
    } finally {
      if (soyOwner) setGuardandoRegistro(false);
    }
  };

  const abrirModalAsignarPasajero = async (pasajero) => {
    if (
      vueloSeleccionado?.tipoServicio === "SALIDAS" &&
      !(mostradores[pasajero.pnr] || "").trim()
    ) {
      toast.info("Captura el mostrador antes de asignar.");
      return;
    }
    try {
      const res = await axios.get(`${API_BASE_URL}api/bitacora/en-turno-detalles`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const estacionUsuario = decoded?.estacion?.trim().toUpperCase();
      const disponibles = (res.data || []).filter(
        (c) => c.estacion?.trim().toUpperCase() === estacionUsuario
      );
      setColaboradores(disponibles);
      setBusquedaSiglas("");
      setPasajeroAsignar(pasajero);
    } catch (error) {
      toast.error("Error al obtener colaboradores");
    }
  };

  const asignarPasajeroAColaborador = async (colab) => {
    if (asignando || !pasajeroAsignar) return;
    setAsignando(true);
    let servicioId = false;
    try {
      servicioId = await registrarServicioPasajero(pasajeroAsignar, false, { paraAsignar: true });
      if (!servicioId) return;

      await axios.put(
        `${API_BASE_URL}api/servicios/msg/${servicioId}/${vueloSeleccionado.tipoServicio}/AM/${vueloSeleccionado.flight_number}`,
        {
          noColaborador: colab.noColaborador,
          statusServicio: "ASIGNADO",
          USUARIO: decoded?.usuario,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast.success(`✅ Servicio asignado a ${colab.siglas || colab.nombreCompleto}`);
      setPasajeroAsignar(null);
    } catch (err) {
      console.error("❌ Error al asignar servicio:", err);
      toast.error(
        servicioId
          ? "El servicio quedó REGISTRADO pero no se pudo asignar. Asígnalo desde Registrados."
          : "❌ Error al asignar servicio"
      );
    } finally {
      setAsignando(false);
    }
  };

  useEffect(() => {
    if (!pasajeros.length) return;
    setPasajerosSeleccionados((prev) => {
      if (!Object.keys(prev).length) return prev;
      const clavesValidas = new Set(pasajeros.map(generarClavePasajero));
      const filtrados = {};
      Object.entries(prev).forEach(([clave, data]) => {
        if (clavesValidas.has(clave)) {
          filtrados[clave] = data;
        }
      });
      return filtrados;
    });
  }, [pasajeros]);

  const toggleSeleccionPasajero = (pasajero) => {
    const clave = generarClavePasajero(pasajero);
    setPasajerosSeleccionados((prev) => {
      const copia = { ...prev };
      if (copia[clave]) {
        delete copia[clave];
      } else {
        copia[clave] = pasajero;
      }
      return copia;
    });
  };

  const limpiarSeleccionPasajeros = () => setPasajerosSeleccionados({});

  const cerrarModalPasajeros = () => {
    setModalAbierto(false);
    setPasajeros([]);
    setBusqueda("");
    setFiltroOrigen("TODOS");
    limpiarSeleccionPasajeros();
  };

  const altaVuelo = async () => {
    const raw = altaForm.flight_number.trim().toUpperCase().replace(/^AM/i, "");
    const flight_number = raw.padStart(4, "0");
    const origenFinal = altaForm.tipoServicio === "SALIDAS" ? estacionIATA : altaForm.latest_departure_airport.trim().toUpperCase();
    const destinoFinal = altaForm.tipoServicio === "LLEGADAS" ? estacionIATA : altaForm.latest_arrival_airport.trim().toUpperCase();
    const campoOrigen = altaForm.tipoServicio === "LLEGADAS" ? altaForm.latest_departure_airport : "";
    const campoDestino = altaForm.tipoServicio === "SALIDAS" ? altaForm.latest_arrival_airport : "";
    if (!raw || !campoOrigen && altaForm.tipoServicio === "LLEGADAS" || !campoDestino && altaForm.tipoServicio === "SALIDAS" ||
        !altaForm.hora_salida || !altaForm.hora_llegada) {
      toast.info("Completa todos los campos antes de registrar.");
      return;
    }
    const hoy = moment().format("YYYY-MM-DD");
    try {
      setGuardandoAlta(true);
      await axios.post(
        `${API_BASE_URL}api/vuelos/manual`,
        {
          flight_number,
          latest_departure_airport: origenFinal,
          latest_arrival_airport: destinoFinal,
          tipoServicio: altaForm.tipoServicio,
          tipoVuelo: altaTipoVueloDetectado,
          published_departure_time: `${hoy}T${altaForm.hora_salida}:00`,
          published_arrival_time: `${hoy}T${altaForm.hora_llegada}:00`,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success("✅ Vuelo registrado correctamente.");
      setModalAltaAbierto(false);
      setAltaForm(altaInicial);
      await fetchData();
    } catch (err) {
      console.error("Error al registrar vuelo:", err);
      toast.error(err.response?.data?.error || "No se pudo registrar el vuelo.");
    } finally {
      setGuardandoAlta(false);
    }
  };

  const abrirModalManual = () => {
    setManualForm(manualInicial);
    setModalManualAbierto(true);
  };

  const registrarManual = async () => {
    const nombre = manualForm.nombre.trim();
    const apellido = manualForm.apellido.trim();
    const noVueloRaw = manualForm.noVuelo.trim().toUpperCase().replace(/^AM/i, "");
    if (!nombre || !apellido || !noVueloRaw) {
      toast.info("Completa nombre, apellido y número de vuelo.");
      return;
    }
    const noVuelo = noVueloRaw.padStart(4, "0");
    const noAsiento = manualForm.noAsiento.trim().toUpperCase() || "S/A";
    const fecha = manualForm.fecha;
    if (fecha < minFechaManual || fecha > maxFechaManual) {
      toast.info("La fecha solo puede ser hoy o el día siguiente.");
      return;
    }
    // El tipo (LLEGADAS/SALIDAS) se detecta según la pestaña activa
    const esLlegada = tabActivo === "LLEGADAS";
    const payload = {
      nombrePax: `${nombre} ${apellido}`,
      aerolinea: "AM",
      noVuelo,
      noAsiento,
      origenVuelo: esLlegada ? "S/D" : estacionIATA,
      destinoVuelo: esLlegada ? estacionIATA : "S/D",
      fechaInput: fecha,
      horaInicio: `${fecha} ${moment().format("HH:mm:ss")}`,
      estacion: decoded?.estacion?.trim().toUpperCase(),
      usuarioInicio: decoded?.id,
      noColaborador: 0,
      statusServicio: "REGISTRADO",
      tipoVuelo: tabActivo,
      int_nac: manualForm.intNac === "NACIONAL" ? "NACIONAL" : "INTERNACIONAL",
      pnr: `MANUAL-${noVuelo}-${moment().valueOf()}`,
      tipoSilla: "WCHR",
      conexion: "S/C",
      noMostrador: null,
      horaVuelo: null,
      sala: null,
      uh: "UH",
      classCode: null,
      priorityCode: null,
    };

    try {
      setGuardandoManual(true);
      await axios.post(`${API_BASE_URL}api/servicios/registrar`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("✅ Pasajero registrado correctamente");
      setModalManualAbierto(false);
      setManualForm(manualInicial);
    } catch (error) {
      if (error.response?.status === 409) {
        toast.warning("El pasajero ya fue registrado para este vuelo.");
      } else {
        console.error("❌ Error al registrar pasajero manual:", error);
        toast.error("No se pudo registrar el pasajero.");
      }
    } finally {
      setGuardandoManual(false);
    }
  };

  const registrarSeleccionMultiple = async () => {
    if (guardandoRegistro) return;
    const seleccionados = Object.values(pasajerosSeleccionados);

    if (!seleccionados.length) {
      toast.info("Selecciona al menos un pasajero para registrar.");
      return;
    }

    setGuardandoRegistro(true);
    let registrados = 0;
    let omitidosPorMostrador = 0;

    try {
    for (const pasajero of seleccionados) {
      if (
        vueloSeleccionado?.tipoServicio === "SALIDAS" &&
        !(mostradores[pasajero.pnr] || "").trim()
      ) {
        omitidosPorMostrador += 1;
        continue;
      }

      const exito = await registrarServicioPasajero(pasajero, false);
      if (exito) registrados += 1;
    }

    if (registrados) {
      toast.success(`✅ ${registrados} pasajero(s) registrados correctamente.`);
    }

    if (omitidosPorMostrador) {
      toast.info(
        `${omitidosPorMostrador} pasajero(s) necesitan mostrador para completar el registro.`
      );
    }

    limpiarSeleccionPasajeros();
    } finally {
      setGuardandoRegistro(false);
    }
  };

  const seleccionarVisibles = () => {
    if (!listaPasajerosVisibles.length) {
      toast.info("No hay pasajeros visibles para seleccionar.");
      return;
    }

    let agregados = 0;

    setPasajerosSeleccionados((prev) => {
      const copia = { ...prev };
      listaPasajerosVisibles.forEach((pasajero) => {
        const clave = generarClavePasajero(pasajero);
        if (!copia[clave]) {
          copia[clave] = pasajero;
          agregados += 1;
        }
      });
      return copia;
    });

    if (agregados > 0) {
      toast.success(`Seleccionados ${agregados} pasajero(s) visibles.`);
    } else {
      toast.info("Todos los pasajeros visibles ya estaban seleccionados.");
    }
  };

  useEffect(() => {
    if (!token) return;
    fetchData();
    const interval = setInterval(fetchData, 300000);
    return () => clearInterval(interval);
  }, [token]);

  useEffect(() => {
    const ahora = moment();
    const scrollToClosest = (vuelos, tipo, ref) => {
      const closestIndex = vuelos.findIndex((v) => {
        const hora =
          tipo === "LLEGADAS"
            ? moment(v.published_arrival_time)
            : moment(v.published_departure_time);
        return hora.isAfter(ahora);
      });

      if (closestIndex !== -1 && ref.current) {
        const row = ref.current.querySelectorAll("tbody tr")[closestIndex];
        if (row) row.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    };

    scrollToClosest(vuelosLlegadas, "LLEGADAS", llegadaRef);
    scrollToClosest(vuelosSalidas, "SALIDAS", salidaRef);
  }, [vuelosLlegadas, vuelosSalidas, tabActivo]);

  const renderTabla = (vuelos, tipo, ref, busquedaTabla, setBusquedaTabla) => {
    const vuelosFiltrados = vuelos.filter((v) =>
      v.flight_number.toLowerCase().includes(busquedaTabla.toLowerCase())
    );

    return (
      <div className="tabla-resumen">
        <div className={`tabla-header-row ${tipo === "LLEGADAS" ? "rv-head-llegadas" : "rv-head-salidas"}`}>
          <div className="tabla-header-info">
            <span className="tabla-header-titulo">
              {tipo === "LLEGADAS" ? "↓  Llegadas" : "↑  Salidas"}
            </span>
            <span className="tabla-header-count">{vuelosFiltrados.length} vuelo{vuelosFiltrados.length !== 1 ? "s" : ""}</span>
          </div>
          <button
            className="btn-alta-tabla"
            title={`Registrar vuelo de ${tipo}`}
            onClick={() => { setAltaForm({ ...altaInicial, tipoServicio: tipo }); setModalAltaAbierto(true); }}
          >+</button>
        </div>

        <div className="tabla-search-area">
          <div className="rv-search-wrapper">
            <span className="rv-search-icon">⌕</span>
            <input
              type="text"
              placeholder="Buscar vuelo..."
              className="input-buscador-vuelo"
              value={busquedaTabla}
              onChange={(e) => setBusquedaTabla(e.target.value)}
            />
          </div>
        </div>

        <div className="scroll-wrapper" ref={ref}>
          <table className="table">
            <thead>
              <tr>
                <th>#</th>
                <th>Vuelo</th>
                <th>Ruta</th>
                <th>Hora</th>
                <th>Tipo</th>
                <th>Sala</th>
              </tr>
            </thead>
            <tbody>
              {vuelosFiltrados.map((vuelo, idx) => {
                const hora =
                  tipo === "LLEGADAS"
                    ? moment(vuelo.published_arrival_time)
                    : moment(vuelo.published_departure_time);

                const claseFila =
                  tipo === "LLEGADAS"
                    ? claseTiempo(vuelo.published_arrival_time)
                    : claseTiempo(vuelo.published_departure_time);

                return (
                  <tr
                    key={vuelo.id}
                    className={claseFila}
                    onClick={() => abrirModalPasajeros(vuelo)}
                  >
                    <td className="rv-idx">{idx + 1}</td>
                    <td><span className="rv-flight-num">{vuelo.flight_number}</span></td>
                    <td>
                      <div className="rv-ruta">
                        <span className="rv-iata">{vuelo.latest_departure_airport}</span>
                        <span className="rv-arrow">→</span>
                        <span className="rv-iata">{vuelo.latest_arrival_airport}</span>
                      </div>
                    </td>
                    <td>{obtenerBadgeHora(hora)}</td>
                    <td>
                      <span className={`rv-tipo-badge ${vuelo.tipoVuelo === "NACIONAL" ? "rv-tipo-nac" : "rv-tipo-int"}`}>
                        {vuelo.tipoVuelo === "NACIONAL" ? "NAC" : "INT"}
                      </span>
                    </td>
                    <td onClick={(e) => e.stopPropagation()}>
                      <input
                        type="text"
                        defaultValue={vuelo.sala || ""}
                        onFocus={(e) => { e.target.dataset.original = e.target.value; }}
                        onClick={(e) => e.stopPropagation()}
                        onBlur={async (e) => {
                          const nuevoValor = e.target.value.trim();
                          const valorOriginal = e.target.dataset.original?.trim();
                          if (nuevoValor === valorOriginal) return;
                          try {
                            await axios.put(
                              `${API_BASE_URL}api/vuelos/actualizar-sala`,
                              { idVuelo: vuelo.id, sala: nuevoValor },
                              { headers: { Authorization: `Bearer ${token}` } }
                            );
                            if (tipo === "SALIDAS") {
                              setVuelosSalidas((prev) =>
                                prev.map((v) => (v.id === vuelo.id ? { ...v, sala: nuevoValor } : v))
                              );
                            } else {
                              setVuelosLlegadas((prev) =>
                                prev.map((v) => (v.id === vuelo.id ? { ...v, sala: nuevoValor } : v))
                              );
                            }
                            toast.success("✅ Sala actualizada");
                          } catch (err) {
                            console.error("❌ Error actualizando sala:", err);
                            toast.error("❌ No se pudo actualizar sala");
                          }
                        }}
                        className="input-sala editable"
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  const opcionesFiltroOrigen = [
    { label: "Todos", value: "TODOS" },
    { label: "SABRE", value: "SABRE" },
    { label: "Otros", value: "OTROS" },
  ];

  const seleccionadosCount = Object.keys(pasajerosSeleccionados).length;

  const terminoBusqueda = busqueda.trim().toLowerCase();

  const pasajerosFiltrados = pasajeros.filter((p) => {
    const textoBusquedaPasajero = (
      (p.Nombre || "") +
        (p.Apellido || "") +
        (p.TipoPasajero || "") +
        (p.pnr || "") +
        (p.Interconexion || "")
    )
      .toString()
      .toLowerCase();

    return textoBusquedaPasajero.includes(terminoBusqueda);
  });

  // Helper: detecta si el pasajero requiere prioridad
  const esPrioritario = (p) =>
    String(p?.classCode || "").toUpperCase() === "J" ||
    (p?.priorityCode != null && String(p.priorityCode).trim() !== "");

  // Orden alfabético por apellido (sin distinguir mayúsculas/acentos)
  const ordenarPorApellido = (arr) =>
    [...arr].sort((a, b) =>
      (a.Apellido || "").localeCompare(b.Apellido || "", "es", { sensitivity: "base" })
    );

  // SABRE: prioritarios primero (dentro del grupo de silla, sí importa)
  const ordenarSabreConPrioridad = (arr) => {
    const prio = ordenarPorApellido(arr.filter(esPrioritario));
    const resto = ordenarPorApellido(arr.filter((p) => !esPrioritario(p)));
    return [...prio, ...resto];
  };

  const pasajerosSabre = ordenarSabreConPrioridad(pasajerosFiltrados.filter((p) => p.OrigenServicio === "SABRE"));
  // Otros: solo alfabético (no se prioriza si no tiene silla)
  const pasajerosOtros = ordenarPorApellido(pasajerosFiltrados.filter((p) => p.OrigenServicio !== "SABRE"));

  // Orden global: SABRE (silla) arriba; dentro de cada grupo prioridad va primero
  const listaPasajerosVisibles =
    filtroOrigen === "SABRE"
      ? pasajerosSabre
      : filtroOrigen === "OTROS"
      ? pasajerosOtros
      : [...pasajerosSabre, ...pasajerosOtros];

  // Conteos para badges
  const totalSillaConPrioridad = pasajeros.filter((p) => p.OrigenServicio === "SABRE" && esPrioritario(p)).length;
  const totalSoloPrioridad = pasajeros.filter((p) => p.OrigenServicio !== "SABRE" && esPrioritario(p)).length;

  const renderRow = (p, idx) => {
    const clave = `${p.pnr}_${p.TipoPasajero}`;
    const sillaSeleccionada = sillasSeleccionadas[clave];
    const claveSeleccion = generarClavePasajero(p);
    const estaSeleccionado = Boolean(pasajerosSeleccionados[claveSeleccion]);
    const esSabre = p.OrigenServicio === "SABRE";
    const esSalida = vueloSeleccionado?.tipoServicio === "SALIDAS";
    const prioritario = esPrioritario(p);
    const claseCabina = String(p.classCode || "").toUpperCase() === "J" ? "Primera" : "Turista";

    return (
      <tr
        key={`${clave}_${idx}`}
        className={`pax-row ${esSabre ? "pax-row-sabre" : "pax-row-otros"} ${estaSeleccionado ? "pax-row-selected" : ""} ${prioritario ? "pax-row-priority" : ""}`}
      >
        <td className="pax-col-check">
          <label className="pasajero-select">
            <input type="checkbox" checked={estaSeleccionado} onChange={() => toggleSeleccionPasajero(p)} />
            <span className="pasajero-select-indicador" />
          </label>
        </td>
        <td className="pax-col-idx">{idx + 1}</td>
        <td className="pax-col-name">
          <div className="pax-name-wrap">
            <span className="pax-apellido">
              {esSabre && <span className="pax-icon-silla" title="Servicio de silla en sistema">♿</span>}
              {p.Apellido}
              {prioritario && <span className="pax-priority-star" title="Prioridad">★</span>}
            </span>
            <span className="pax-nombre">{p.Nombre}</span>
          </div>
        </td>
        <td className="pax-col-asiento">
          <span className="chip-asiento">{p.TipoPasajero || "—"}</span>
        </td>
        <td className="pax-col-clase">
          <span className={`chip-clase ${p.classCode === "J" ? "chip-clase-j" : ""}`}>
            {p.classCode || "—"}
          </span>
          <span className="chip-clase-sub">{p.classCode ? claseCabina : ""}</span>
        </td>
        <td className="pax-col-priority">
          {prioritario ? (
            <span className="chip-priority" title={`priorityCode: ${p.priorityCode || "—"}`}>
              ⚑ {p.priorityCode || "PRIO"}
            </span>
          ) : (
            <span className="pax-col-empty">—</span>
          )}
        </td>
        <td className="pax-col-origen">
          <span className={`chip-origen ${esSabre ? "chip-sabre" : ""}`}>
            {p.OrigenServicio || "Sin origen"}
          </span>
        </td>
        <td className="pax-col-pnr">{p.pnr || "—"}</td>
        <td className="pax-col-conex">{p.Interconexion || "—"}</td>
        <td className="pax-col-silla">
          <div className="pax-silla-group">
            {["WCHR", "SP", "PAS"].map((tipo) => (
              <label
                key={tipo}
                className={`silla-option ${sillaSeleccionada === tipo ? "silla-option-activa" : ""}`}
              >
                <input
                  type="checkbox"
                  checked={sillaSeleccionada === tipo}
                  onChange={() =>
                    setSillasSeleccionadas((prev) => ({
                      ...prev,
                      [clave]: prev[clave] === tipo ? null : tipo,
                    }))
                  }
                />
                <span>{tipo}</span>
              </label>
            ))}
          </div>
        </td>
        {esSalida && (
          <td className="pax-col-mostrador">
            <input
              type="text"
              className="input-mostrador"
              placeholder="Mostrador"
              value={mostradores[p.pnr] || ""}
              onChange={(e) =>
                setMostradores((prev) => ({ ...prev, [p.pnr]: e.target.value }))
              }
            />
          </td>
        )}
        <td className="pax-col-action">
          <div className="pax-action-group">
            <button className="btn-registrar" onClick={() => registrarServicioPasajero(p)} disabled={guardandoRegistro || asignando}>
              {guardandoRegistro ? "Registrando..." : "Registrar"}
            </button>
            <button className="btn-registrar btn-asignar-pax" onClick={() => abrirModalAsignarPasajero(p)} disabled={guardandoRegistro || asignando}>
              Asignar
            </button>
          </div>
        </td>
      </tr>
    );
  };

  if (loadingPage) {
    return (
      <div className="resumen-vuelos-container">
        <div className="page-loading-overlay">
          <div className="page-loading-spinner" />
          <p className="page-loading-text">Cargando resumen de vuelos...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="resumen-vuelos-container">
      {cargandoPasajeros && (
        <div className="loader-overlay">
          <div className="loader-card">
            <div className="loader-ring-wrapper">
              <div className="loader-ring" />
              <span className="loader-plane">✈</span>
            </div>
            <p className="loader-texto">Cargando lista de pasajeros</p>
            <div className="loader-dots">
              <span /><span /><span />
            </div>
          </div>
        </div>
      )}

      {modalAltaAbierto && (
        <div className="modal-overlay-pasajeros" onClick={() => setModalAltaAbierto(false)}>
          <div className="modal-busqueda-manual" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-header-content">
                <h2 className="modal-titulo">Registrar vuelo manualmente</h2>
              </div>
              <button className="modal-cerrar-btn" onClick={() => setModalAltaAbierto(false)}>✖</button>
            </div>
            <div className="busqueda-manual-body">
              <div className="busqueda-manual-form">
                <div className="busqueda-campos-fila">
                  <div className="busqueda-campo">
                    <label className="filtro-origen-label">Número de vuelo</label>
                    <input
                      type="text"
                      className="input-buscador"
                      placeholder="Ej. 26 o AM450"
                      value={altaForm.flight_number}
                      onChange={(e) => setAltaForm((p) => ({ ...p, flight_number: e.target.value.toUpperCase() }))}
                      autoFocus
                    />
                  </div>
                  {altaForm.tipoServicio === "LLEGADAS" ? (
                    <div className="busqueda-campo">
                      <label className="filtro-origen-label">Origen (IATA)</label>
                      <input
                        type="text"
                        className="input-buscador"
                        placeholder="Ej. AMS"
                        maxLength={3}
                        value={altaForm.latest_departure_airport}
                        onChange={(e) => setAltaForm((p) => ({ ...p, latest_departure_airport: e.target.value.toUpperCase() }))}
                      />
                    </div>
                  ) : (
                    <div className="busqueda-campo">
                      <label className="filtro-origen-label">Origen</label>
                      <span className="alta-tipo-badge">{estacionIATA}</span>
                    </div>
                  )}
                  {altaForm.tipoServicio === "SALIDAS" ? (
                    <div className="busqueda-campo">
                      <label className="filtro-origen-label">Destino (IATA)</label>
                      <input
                        type="text"
                        className="input-buscador"
                        placeholder="Ej. GDL"
                        maxLength={3}
                        value={altaForm.latest_arrival_airport}
                        onChange={(e) => setAltaForm((p) => ({ ...p, latest_arrival_airport: e.target.value.toUpperCase() }))}
                      />
                    </div>
                  ) : (
                    <div className="busqueda-campo">
                      <label className="filtro-origen-label">Destino</label>
                      <span className="alta-tipo-badge">{estacionIATA}</span>
                    </div>
                  )}
                </div>
                <div className="busqueda-campos-fila">
                  <div className="busqueda-campo">
                    <label className="filtro-origen-label">Hora de salida</label>
                    <input
                      type="time"
                      className="input-fecha"
                      value={altaForm.hora_salida}
                      onChange={(e) => setAltaForm((p) => ({ ...p, hora_salida: e.target.value }))}
                    />
                  </div>
                  <div className="busqueda-campo">
                    <label className="filtro-origen-label">Hora de llegada</label>
                    <input
                      type="time"
                      className="input-fecha"
                      value={altaForm.hora_llegada}
                      onChange={(e) => setAltaForm((p) => ({ ...p, hora_llegada: e.target.value }))}
                    />
                  </div>
                  <div className="busqueda-campo">
                    <label className="filtro-origen-label">Tipo de vuelo</label>
                    <span className={`alta-tipo-badge ${altaTipoVueloDetectado === "NACIONAL" ? "alta-badge-nacional" : "alta-badge-inter"}`}>
                      {altaTipoVueloDetectado}
                    </span>
                  </div>
                </div>
              </div>
              <div className="busqueda-manual-actions">
                <button
                  type="button"
                  className="btn-registrar"
                  onClick={altaVuelo}
                  disabled={guardandoAlta}
                >
                  {guardandoAlta ? "Registrando..." : "Registrar vuelo"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {modalAbierto && (
        <div className="modal-overlay-pasajeros" onClick={cerrarModalPasajeros}>
          <div className="modal-pasajeros" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-header-content">
                <h2 className="modal-titulo">
                  Vuelo {vueloSeleccionado?.flight_number} —{" "}
                  {vueloSeleccionado?.latest_departure_airport} → {vueloSeleccionado?.latest_arrival_airport}
                </h2>
                <div className="modal-resumen-badges">
                  <div className="resumen-badge resumen-badge-total">
                    <span className="resumen-badge-num">{totalPasajeros}</span>
                    <span className="resumen-badge-label">Pasajeros totales</span>
                  </div>
                  <div className="resumen-badge resumen-badge-sabre">
                    <span className="resumen-badge-num">{totalSillasSistema}</span>
                    <span className="resumen-badge-label">Sillas en sistema</span>
                  </div>
                  <div className="resumen-badge resumen-badge-otros">
                    <span className="resumen-badge-num">{totalPasajeros - totalSillasSistema}</span>
                    <span className="resumen-badge-label">Otros</span>
                  </div>
                  <div className="resumen-badge resumen-badge-silla-prio">
                    <span className="resumen-badge-num">{totalSillaConPrioridad}</span>
                    <span className="resumen-badge-label">♿ Silla + Prio</span>
                  </div>
                  <div className="resumen-badge resumen-badge-priority">
                    <span className="resumen-badge-num">{totalSoloPrioridad}</span>
                    <span className="resumen-badge-label">★ Solo Prio</span>
                  </div>
                </div>
              </div>

              <button className="modal-cerrar-btn" onClick={cerrarModalPasajeros}>
                ✖
              </button>
            </div>

            {cargandoPasajeros && (
              <div className="pasajeros-loading">
                <span className="spinner" aria-hidden="true" />
                Cargando pasajeros...
              </div>
            )}

            <div className="modal-body">
              <div className="modal-filtros">
                <div className="buscadores">
                  <div className="fecha-pasajeros-block">
                    <label className="filtro-origen-label">Fecha pasajeros</label>
                    <input
                      type="date"
                      className="input-fecha"
                      value={fechaPasajeros}
                      min={minFechaPasajeros}
                      max={maxFechaPasajeros}
                      onChange={onChangeFechaPasajeros}
                      disabled={cargandoPasajeros}
                    />
                  </div>
                  <input
                    type="text"
                    className="input-buscador"
                    placeholder="🔍 Buscar por nombre, apellido, asiento, PNR o conexión"
                    value={busqueda}
                    onChange={(e) => setBusqueda(e.target.value)}
                  />
                  <div className="filtro-origen">
                    <span className="filtro-origen-label">Origen servicio</span>
                    <div className="filtro-origen-botones">
                      {opcionesFiltroOrigen.map((opcion) => (
                        <button
                          key={opcion.value}
                          type="button"
                          className={`btn-secundario btn-filtro-origen ${filtroOrigen === opcion.value ? "activo" : ""}`}
                          onClick={() => setFiltroOrigen(opcion.value)}
                        >
                          {opcion.label}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="leyenda-origen">
                  <span className="leyenda-item leyenda-sabre">
                    <span className="leyenda-dot" />
                    SABRE
                  </span>
                  <span className="leyenda-item leyenda-otros">
                    <span className="leyenda-dot" />
                    Otros orígenes
                  </span>
                </div>

                <div className="multi-acciones">
                  <span className="contador-seleccion">
                    {seleccionadosCount
                      ? `${seleccionadosCount} pasajero(s) seleccionado(s)`
                      : "Sin pasajeros seleccionados"}
                  </span>
                  <div className="multi-acciones-botones">
                    <button type="button" className="btn-secundario" onClick={seleccionarVisibles} disabled={!listaPasajerosVisibles.length}>
                      Seleccionar visibles
                    </button>
                    <button type="button" className="btn-secundario" onClick={limpiarSeleccionPasajeros} disabled={!seleccionadosCount}>
                      Limpiar selección
                    </button>
                    <button
                      type="button"
                      className="btn-registrar-seleccion"
                      onClick={registrarSeleccionMultiple}
                      disabled={!seleccionadosCount || guardandoRegistro}
                    >
                      {guardandoRegistro ? "Registrando..." : "Registrar seleccionados"}
                    </button>
                  </div>
                </div>
              </div>
              <div className="pasajeros-wrapper">
                <table className="pax-table">
                  <thead>
                    <tr>
                      <th className="pax-col-check"></th>
                      <th className="pax-col-idx">#</th>
                      <th className="pax-col-name">Pasajero</th>
                      <th className="pax-col-asiento">Asiento</th>
                      <th className="pax-col-clase">Clase</th>
                      <th className="pax-col-priority">Prioridad</th>
                      <th className="pax-col-origen">Origen</th>
                      <th className="pax-col-pnr">PNR</th>
                      <th className="pax-col-conex">Conexión</th>
                      <th className="pax-col-silla">Silla</th>
                      {vueloSeleccionado?.tipoServicio === "SALIDAS" && (
                        <th className="pax-col-mostrador">Mostrador</th>
                      )}
                      <th className="pax-col-action"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {listaPasajerosVisibles.length === 0 ? (
                      <tr>
                        <td colSpan={vueloSeleccionado?.tipoServicio === "SALIDAS" ? 12 : 11} className="pax-empty">
                          Sin pasajeros que mostrar.
                        </td>
                      </tr>
                    ) : (
                      listaPasajerosVisibles.map((p, i) => renderRow(p, i))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="rv-page-header">
        <div className="rv-page-header-left">
          <h1 className="rv-page-title">Vuelos del día</h1>
          <p className="rv-page-subtitle">
            {decoded?.estacion?.toUpperCase()} · {moment().format("dddd D [de] MMMM [de] YYYY")}
          </p>
        </div>
        <div className="rv-total-resumen">
          <span className="rv-total-num">{vuelosLlegadas.length + vuelosSalidas.length}</span>
          <span className="rv-total-label">vuelos hoy</span>
        </div>
      </div>

      <div className="rv-tabbar" role="tablist" aria-label="Llegadas y salidas">
        <button
          type="button"
          role="tab"
          aria-selected={tabActivo === "LLEGADAS"}
          className={`rv-tab rv-tab-llegadas ${tabActivo === "LLEGADAS" ? "rv-tab-activo" : ""}`}
          onClick={() => setTabActivo("LLEGADAS")}
        >
          <span className="rv-tab-icon" aria-hidden="true">↓</span>
          <span className="rv-tab-label">Llegadas</span>
          <span className="rv-tab-count">{vuelosLlegadas.length}</span>
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={tabActivo === "SALIDAS"}
          className={`rv-tab rv-tab-salidas ${tabActivo === "SALIDAS" ? "rv-tab-activo" : ""}`}
          onClick={() => setTabActivo("SALIDAS")}
        >
          <span className="rv-tab-icon" aria-hidden="true">↑</span>
          <span className="rv-tab-label">Salidas</span>
          <span className="rv-tab-count">{vuelosSalidas.length}</span>
        </button>
      </div>

      <div className="tabla-unica">
        {tabActivo === "LLEGADAS"
          ? renderTabla(vuelosLlegadas, "LLEGADAS", llegadaRef, busquedaLlegadas, setBusquedaLlegadas)
          : renderTabla(vuelosSalidas, "SALIDAS", salidaRef, busquedaSalidas, setBusquedaSalidas)}
      </div>

      {/* FAB: registrar pasajero que no viene en la lista */}
      <button
        type="button"
        className="rv-fab"
        title={`Registrar pasajero manual (${tabActivo === "LLEGADAS" ? "Llegada" : "Salida"})`}
        onClick={abrirModalManual}
      >
        +
      </button>

      {modalManualAbierto && (
        <div className="modal-overlay-pasajeros" onClick={() => setModalManualAbierto(false)}>
          <div className="modal-busqueda-manual" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-header-content">
                <h2 className="modal-titulo">Registrar pasajero manual</h2>
                <span className={`rv-tipo-badge ${tabActivo === "LLEGADAS" ? "rv-tipo-int" : "rv-tipo-nac"}`}>
                  {tabActivo === "LLEGADAS" ? "↓ LLEGADA" : "↑ SALIDA"}
                </span>
              </div>
              <button className="modal-cerrar-btn" onClick={() => setModalManualAbierto(false)}>✖</button>
            </div>
            <div className="busqueda-manual-body">
              <div className="busqueda-manual-form">
                <div className="busqueda-campos-fila">
                  <div className="busqueda-campo">
                    <label className="filtro-origen-label">Nombre(s)</label>
                    <input
                      type="text"
                      className="input-buscador"
                      placeholder="Ej. Juan"
                      value={manualForm.nombre}
                      onChange={(e) => setManualForm((p) => ({ ...p, nombre: e.target.value }))}
                      autoFocus
                    />
                  </div>
                  <div className="busqueda-campo">
                    <label className="filtro-origen-label">Apellido(s)</label>
                    <input
                      type="text"
                      className="input-buscador"
                      placeholder="Ej. Pérez"
                      value={manualForm.apellido}
                      onChange={(e) => setManualForm((p) => ({ ...p, apellido: e.target.value }))}
                    />
                  </div>
                </div>
                <div className="busqueda-campos-fila">
                  <div className="busqueda-campo">
                    <label className="filtro-origen-label">Número de vuelo</label>
                    <input
                      type="text"
                      className="input-buscador"
                      placeholder="Ej. 26 o AM450"
                      value={manualForm.noVuelo}
                      onChange={(e) => setManualForm((p) => ({ ...p, noVuelo: e.target.value.toUpperCase() }))}
                    />
                  </div>
                  <div className="busqueda-campo">
                    <label className="filtro-origen-label">Asiento (opcional)</label>
                    <input
                      type="text"
                      className="input-buscador"
                      placeholder="Ej. 12A"
                      value={manualForm.noAsiento}
                      onChange={(e) => setManualForm((p) => ({ ...p, noAsiento: e.target.value.toUpperCase() }))}
                    />
                  </div>
                </div>
                <div className="busqueda-campos-fila">
                  <div className="busqueda-campo">
                    <label className="filtro-origen-label">Fecha del servicio</label>
                    <input
                      type="date"
                      className="input-fecha"
                      value={manualForm.fecha}
                      min={minFechaManual}
                      max={maxFechaManual}
                      onChange={(e) => setManualForm((p) => ({ ...p, fecha: e.target.value }))}
                    />
                  </div>
                  <div className="filtro-origen">
                    <label className="filtro-origen-label">Tipo de vuelo</label>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button
                        type="button"
                        className={`btn-filtro-tipo ${manualForm.intNac === 'NACIONAL' ? 'activo' : ''}`}
                        onClick={() => setManualForm((p) => ({ ...p, intNac: 'NACIONAL' }))}
                        style={{ flex: 1 }}
                      >
                        Nacional
                      </button>
                      <button
                        type="button"
                        className={`btn-filtro-tipo ${manualForm.intNac === 'INTERNACIONAL' ? 'activo' : ''}`}
                        onClick={() => setManualForm((p) => ({ ...p, intNac: 'INTERNACIONAL' }))}
                        style={{ flex: 1 }}
                      >
                        Internacional
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="busqueda-manual-actions">
                <button
                  type="button"
                  className="btn-registrar"
                  onClick={registrarManual}
                  disabled={guardandoManual}
                >
                  {guardandoManual ? "Guardando..." : "Guardar"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {pasajeroAsignar && (() => {
        const filtro = busquedaSiglas.trim();
        const visibles = colaboradores.filter((c) =>
          [c.siglas, c.nombreCompleto, String(c.noColaborador)]
            .filter(Boolean)
            .join(" ")
            .toUpperCase()
            .includes(filtro)
        );
        return (
          <div className="ao-overlay" onClick={() => !asignando && setPasajeroAsignar(null)}>
            <div
              className="ao-modal"
              role="dialog"
              aria-modal="true"
              aria-labelledby="ao-titulo"
              onClick={(e) => e.stopPropagation()}
            >
              <header className="ao-head">
                <div className="ao-head-text">
                  <p id="ao-titulo" className="ao-titulo" role="heading" aria-level="2">Asignar servicio</p>
                  <p className="ao-pax">
                    <strong>{pasajeroAsignar.Apellido} {pasajeroAsignar.Nombre}</strong>
                    <span className="ao-pax-meta">
                      Asiento {pasajeroAsignar.TipoPasajero || "—"} · Vuelo {vueloSeleccionado?.flight_number}
                    </span>
                  </p>
                </div>
                <button
                  type="button"
                  className="ao-cerrar"
                  aria-label="Cerrar"
                  onClick={() => setPasajeroAsignar(null)}
                  disabled={asignando}
                >
                  ✕
                </button>
              </header>

              <div className="ao-buscar">
                <input
                  type="search"
                  className="ao-input"
                  placeholder="Buscar por siglas, nombre o número"
                  value={busquedaSiglas}
                  onChange={(e) => setBusquedaSiglas(e.target.value.toUpperCase())}
                  autoFocus
                />
                <span className="ao-conteo">
                  {visibles.length} de {colaboradores.length} en turno
                </span>
              </div>

              <ul className="ao-lista">
                {visibles.length === 0 ? (
                  <li className="ao-vacio">
                    {colaboradores.length === 0
                      ? "No hay operadores en turno en tu estación. Registra su entrada en Bitácora para poder asignarlos."
                      : "Ningún operador coincide con la búsqueda."}
                  </li>
                ) : (
                  visibles.map((c) => (
                    <li key={c.noColaborador}>
                      <button
                        type="button"
                        className="ao-op"
                        onClick={() => asignarPasajeroAColaborador(c)}
                        disabled={asignando}
                      >
                        <span className="ao-siglas">{c.siglas || "—"}</span>
                        <span className="ao-op-info">
                          <span className="ao-op-nombre">{c.nombreCompleto}</span>
                          <span className="ao-op-num">#{c.noColaborador}</span>
                        </span>
                        <span className="ao-op-accion">{asignando ? "Asignando…" : "Asignar"}</span>
                      </button>
                    </li>
                  ))
                )}
              </ul>
            </div>
          </div>
        );
      })()}

      <ToastContainer />
    </div>
  );
};

export default ResumenVuelosPage;
